module.exports = __webpack_public_path__ + "img/logo-ordering.594266ff.png";